/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { ReleaseHttpRequest } from '../../models/release-http-request';
import { ReleaseResponse } from '../../models/release-response';

export interface CasesCaseIdStepsStepIdReleasePost$Params {
  caseId: string;
  stepId: string;
      body: ReleaseHttpRequest
}

export function casesCaseIdStepsStepIdReleasePost(http: HttpClient, rootUrl: string, params: CasesCaseIdStepsStepIdReleasePost$Params, context?: HttpContext): Observable<StrictHttpResponse<ReleaseResponse>> {
  const rb = new RequestBuilder(rootUrl, casesCaseIdStepsStepIdReleasePost.PATH, 'post');
  if (params) {
    rb.path('caseId', params.caseId, {});
    rb.path('stepId', params.stepId, {});
    rb.body(params.body, 'application/json');
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'application/json', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<ReleaseResponse>;
    })
  );
}

casesCaseIdStepsStepIdReleasePost.PATH = '/cases/{caseId}/steps/{stepId}/release';
